module.exports = __webpack_public_path__ + "img/Awards.1687038f.png";